import React from 'react';

import QuotaWinterSellers  from 'components/Tvendo/Sale/QuotaBPartner/WinterCuotas/QuotaSellers/List.js';

export default function () {
  return <QuotaWinterSellers  />;
}